export default __webpack_public_path__ + "static/media/musty.0c538b02.jpg";